var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-col",
    { attrs: { cols: _vm.cols } },
    [
      _c("csp-table", {
        attrs: {
          icon: "inticon-autoclaim_company",
          "items-ajax-url": _vm.itemsAjaxUrl,
          "table-headline": "Zugehörige Firmen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }